module.exports = __webpack_public_path__ + "img/mental.4da866e7.png";